import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { useSetRecoilState } from 'recoil';

import styles from '../../theme/styles';
import EventHeader from '../Header/EventHeader';
import { HELP_PHONE } from '../../common/data/Constants';
import { LogAction } from '../../common/recoil/atom/LogAction';

const ErrorScreen = (props) => {
  const { classes, errorMessage } = props;
  const setAction = useSetRecoilState(LogAction);

  const title = 'Error';
  const subTitle = '';

  useEffect(() => {
    setAction({
      context: 'error-screen',
      subject: 'app',
      object: errorMessage,
      verb: 'shown',
    });
  }, [errorMessage, setAction]);

  return (
    <div className={classes.eventContainer}>
      <EventHeader
        headerText={title}
        subHeaderText={subTitle}
      />

      <div className={classes.errorContainer}>
        <Typography>
          It looks like you encountered an error when trying to schedule the
          appointment. To finish scheduling, please call us at{' '}
          <a href={`tel:${HELP_PHONE.tel}`}>{HELP_PHONE.display}</a>.
        </Typography>

        {errorMessage && <Typography>Error: {errorMessage}</Typography>}
      </div>
    </div>
  );
};

ErrorScreen.propTypes = {
  classes: PropTypes.object.isRequired,
  errorMessage: PropTypes.string,
};

export default withStyles(styles)(ErrorScreen);
